/* =========================================================
PLEWS TYRES MÉXICO — COLLECTION JS
========================================================= */
(function(){
  'use strict';
  const roots = document.querySelectorAll('[data-pc-root]');
  if(!roots.length) return;

  roots.forEach((root) => {
    const cards = Array.from(root.querySelectorAll('.pc-product-card'));
    const chips = Array.from(root.querySelectorAll('[data-filter]'));
    const count = root.querySelector('[data-visible-count]');
    const sort = root.querySelector('[data-pc-sort]');
    const grid = root.querySelector('[data-pc-grid]');

    const updateCount = () => {
      const visible = cards.filter(card => card.style.display !== 'none').length;
      if(count) count.textContent = String(visible);
    };

    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        chips.forEach(c => c.classList.remove('is-active'));
        chip.classList.add('is-active');
        const filter = chip.dataset.filter || 'all';
        cards.forEach(card => {
          const categories = card.dataset.category || '';
          card.style.display = filter === 'all' || categories.includes(filter) ? '' : 'none';
        });
        updateCount();
      });
    });

    if(sort && grid){
      sort.addEventListener('change', () => {
        const sorted = cards.slice().sort((a,b) => {
          const pa = Number(a.dataset.price || 0);
          const pb = Number(b.dataset.price || 0);
          const sa = Number(a.dataset.stock || 0);
          const sb = Number(b.dataset.stock || 0);
          if(sort.value === 'price-asc') return pa - pb;
          if(sort.value === 'price-desc') return pb - pa;
          if(sort.value === 'stock-desc') return sb - sa;
          return Number(a.dataset-index || 0) - Number(b.dataset-index || 0);
        });
        sorted.forEach(card => grid.appendChild(card));
      });
    }

    root.querySelectorAll('[data-pc-add-form]').forEach(form => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('.pc-add');
        const original = button ? button.textContent : '';
        if(button){ button.disabled = true; button.textContent = 'Agregando'; }
        try{
          const formData = new FormData(form);
          const response = await fetch('/cart/add.js', {
            method:'POST',
            headers:{ 'Accept':'application/json' },
            body:formData
          });
          if(!response.ok) throw new Error('No se pudo agregar al carrito');
          if(button){
            button.textContent = 'Agregado';
            button.classList.add('is-added');
          }
          try{
            const cart = await fetch('/cart.js').then(r => r.json());
            document.querySelectorAll('[data-cart-count], .ptm-cart b, .ptp-cart-count').forEach(el => { el.textContent = cart.item_count; });
          }catch(e){}
        }catch(error){
          if(button) button.textContent = 'Intenta de nuevo';
        }finally{
          setTimeout(() => {
            if(button){
              button.disabled = false;
              button.textContent = original;
              button.classList.remove('is-added');
            }
          }, 1600);
        }
      });
    });

    const revealEls = root.querySelectorAll('.pc-reveal');
    if('IntersectionObserver' in window){
      const io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if(!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold:.14, rootMargin:'0px 0px -40px 0px' });
      revealEls.forEach(el => io.observe(el));
    } else {
      revealEls.forEach(el => el.classList.add('is-visible'));
    }

    updateCount();
  });
})();
